module.exports = __webpack_public_path__ + "static/media/35BE5D38-9B73-4064-A6E2-F528D3A06900.4b863111.jpeg";